import React from "react";
import ChapterFigure from "./chapterFigure";

const ChapterCards = ({ chapters, selectFigures, sortOrder }) => {
  const sortedChapters =
    sortOrder === "az" ? chapters : chapters.slice().reverse();
  return (
    <ul className="figures-results">
      {sortedChapters.map(chapter => {
        const { figures, title } = chapter;
        const cover =
          figures[0].path || figures[0].thumbnailURL || figures[0].imageURL;
        return (
          <ChapterFigure
            key={figures[0].cfi}
            cover={cover}
            count={figures.length}
            onClick={() => selectFigures(figures)}
            title={title}
          />
        );
      })}
    </ul>
  );
};

export default ChapterCards;
